import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import slider1 from "assets/img/cl01.jpg";
import slider2 from "assets/img/cl02.jpg";
import slider3 from "assets/img/cl03.jpg";
import slider4 from "assets/img/cl04.jpg";

import styles from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.js";

const useStyles = makeStyles(styles);

export default function SectionCarouselCampusLife() {
  const classes = useStyles();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };
  return (
    <div className={classes.section}>
      <div className={{}}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} className={classes.marginAuto}>
            <Card carousel>
              <Carousel {...settings}>
                <div>
                  <img
                    src={slider1}
                    alt="First slide"
                    className="slick-image"
                    style={{
                      height: 500
                    }}
                  />
                </div>
                <div>
                  <img
                    src={slider2}
                    alt="Second slide"
                    className="slick-image"
                    style={{
                      height: 500
                    }}
                  />
                </div>
                <div>
                  <img
                    src={slider3}
                    alt="Third slide"
                    className="slick-image"
                    style={{
                      height: 500
                    }}
                  />
                </div>
                <div>
                  <img
                    src={slider4}
                    alt="Third slide"
                    className="slick-image"
                    style={{
                      height: 500
                    }}
                  />
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
